import { combineReducers } from 'redux';
import auth from './auth';
import contact from './contact';
import activity from './activity';

export default combineReducers({ auth, contact, activity });



// WEBPACK FOOTER //
// ./src/reducers/index.js